import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvancedComponent } from './advanced.component';
import {ArmSideNavModule} from '../../components/arm-side-nav/arm-side-nav.module';
import { AdvancedUsersComponent } from './advanced-users/advanced-users.component';
import { AdvancedCallsComponent } from './advanced-calls/advanced-calls.component';
import {ArmFormModule} from '../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MaterialModule} from '../../material.module';
import {FormsModule} from '@angular/forms';
import { AdvancedStatisticsComponent } from './advanced-statistics/advanced-statistics.component';



@NgModule({
  declarations: [AdvancedComponent, AdvancedUsersComponent, AdvancedCallsComponent, AdvancedStatisticsComponent],
  imports: [
    CommonModule,
    ArmSideNavModule,
    ArmFormModule,
    ArmFormTitleModule,
    MaterialModule,
    FormsModule
  ]
})
export class AdvancedModule { }
